import React from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const NotFound = () => (
  <Box
    sx={{
      py: { xs: 10, md: 16 },
      background:
        "linear-gradient(180deg, rgba(13,24,39,0.98), rgba(19,33,52,0.96), rgba(30,45,67,0.94))",
      color: "#fff",
      position: "relative",
      overflow: "hidden",
      "&::after": {
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)",
        backgroundSize: "84px 84px",
        opacity: 0.14,
      },
    }}
  >
    <Container sx={{ position: "relative", zIndex: 1 }}>
      <Box className="eyebrow" sx={{ color: "#fff", "&::before": { background: "linear-gradient(90deg, rgba(255,255,255,0.14), #dec095)" } }}>
        Refwa
      </Box>
      <Typography
        variant="h1"
        sx={{ mt: 2, fontSize: { xs: "3rem", md: "4.8rem" }, lineHeight: 0.96, maxWidth: 720 }}
      >
        Page Not Found
      </Typography>
      <Typography
        variant="body1"
        sx={{ mt: 2.5, maxWidth: 620, color: "rgba(255,255,255,0.78)", lineHeight: 1.8 }}
      >
        Return to Refwa's main pages or contact the company directly for
        assistance.
      </Typography>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mt: 4 }}>
        <Button component={RouterLink} to="/" variant="contained" size="large">
          Return Home
        </Button>
        <Button
          component={RouterLink}
          to="/contact"
          variant="outlined"
          size="large"
          sx={{
            color: "#fff",
            borderColor: "rgba(255,255,255,0.35)",
            "&:hover": {
              borderColor: "#fff",
              backgroundColor: "rgba(255,255,255,0.06)",
            },
          }}
        >
          Contact Refwa
        </Button>
      </Stack>
    </Container>
  </Box>
);

export default NotFound;
